/* Perrone newsletter campaign provenance v1. No personal data stored. */
(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) return;
  var KEY = 'perrone-newsletter-campaign-v1';
  var CAMPAIGN = 'prelancio_crusco_nov2026';
  var TAG = 'newsletter_meta_prelancio_crusco_nov2026';
  var TTL = 24 * 60 * 60 * 1000;
  var params = new URLSearchParams(window.location.search);
  var candidate = params.get('utm_source') === 'meta' &&
    params.get('utm_medium') === 'paid_social' &&
    params.get('utm_campaign') === CAMPAIGN;
  function allowed() {
    try {
      var p = window.Shopify && window.Shopify.customerPrivacy;
      return !!p && p.marketingAllowed() === true &&
        p.analyticsProcessingAllowed() === true && p.saleOfDataAllowed() === true;
    } catch (e) { return false; }
  }
  function clear() { try { sessionStorage.removeItem(KEY); } catch (e) {} }
  function read() {
    if (!allowed()) return null;
    try {
      var x = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (!x || x.campaign !== CAMPAIGN || !(x.at > 0) ||
          Date.now() - x.at > TTL || x.at > Date.now()) { clear(); return null; }
      return x;
    } catch (e) { return null; }
  }
  function sync() {
    if (!allowed()) { clear(); return; }
    if (!candidate || read()) return;
    var x = {campaign: CAMPAIGN, source: 'meta', medium: 'paid_social', at: Date.now()};
    ['utm_content', 'utm_term', 'ad_id'].forEach(function (k) {
      var v = params.get(k) || '';
      if (/^[a-zA-Z0-9_-]{1,100}$/.test(v)) x[k] = v;
    });
    try { sessionStorage.setItem(KEY, JSON.stringify(x)); } catch (e) {}
  }
  function tagForm(event) {
    var f = event.target;
    if (!f || ['PerroneNewsletterForm', 'PerroneNewsletterSectionForm'].indexOf(f.id) < 0) return;
    var input = f.querySelector('input[name="contact[tags]"]');
    if (!input) return;
    var tags = input.value.split(',').map(function (t) { return t.trim(); })
      .filter(function (t) { return t && t !== TAG; });
    sync();
    if (read() && f.checkValidity()) tags.push(TAG);
    input.value = tags.join(',');
  }
  document.addEventListener('submit', tagForm, true);
  document.addEventListener('visitorConsentCollected', sync);
  sync();
  if (window.Shopify && !window.Shopify.customerPrivacy && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{name:'consent-tracking-api', version:'0.2'}], sync);
  }
})();
